import React, { useState, useCallback, useMemo } from 'react';
import { useLocation, Link } from "react-router-dom";

import logo from 'static/mobile-logo.svg';
import logoWithText from 'static/logo.svg';
import DropDownIcon from 'static/drop-down-icon.svg';
import LinkIcon from 'static/link-icon.svg';
import { routesEnum } from '../../constants';
import './styles.scss';

const MobileHeader = () => {
  const {pathname} = useLocation();
  const [showNav, setShowNav] = useState(false);

  const navItem = useMemo(
    () => routesEnum[pathname],
    [pathname]
  );

  const toggleNav = useCallback(
    () => setShowNav(!showNav),
    [showNav]
  );


  return (
    <div id="mobile-nav" className="nav">
      <div className={navItem ? 'head-justify-left' : 'head'}>
        <Link className="brand-logo" to="/">
          <img alt="covid care logo" className="logo" src={navItem ? logo : logoWithText} />
        </Link>
        { navItem ? (
            <div className="nav-button" onClick={toggleNav}>
              {navItem.title}
              <img src={DropDownIcon} alt="dropdown icon" />
            </div>
          ) : (
            <Link to="/">
              <div className="back"> ← Back </div>
            </Link>
          )
        }
      </div>
      { navItem &&
        <div
          className={`nav-dropdown ${showNav ? 'nav-animation-show' : 'nav-animation-hide'}`}
          onClick={() => setShowNav(false)}
        >
          { Object.keys(routesEnum).map( route => (
            <Link to={route}>
                <div className={pathname === route ? 'active' : ''}>
                  {routesEnum[route].title }
              </div>
            </Link>)
          )}
          <a target="_blank" rel="noopener noreferrer" href="https://delhicovidupdates.in/">
            <div>
              Blog <img className="link-icon" alt="link icon" src={LinkIcon} />
            </div>
          </a>
        </div>
      }
    </div>
  );
}

export default MobileHeader;
